import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=26a4a6bf&scoped=true&lang=pug&"
import script from "./ButtonBase.vue?vue&type=script&lang=js&"
export * from "./ButtonBase.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=26a4a6bf&scoped=true&lang=scss&"
import style1 from "./ButtonBase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4a6bf",
  null
  
)

export default component.exports